import { ContentSection } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NoConnectionNotification } from '../components/notifications/no-connection/NoConnectionNotification';
import { PageHeader } from '../components/page-header/PageHeader';
import { TotalEarlySettlement } from '../components/early-settlement/total-early-settlement';

interface RouteParams {
    contractId: string;
}

export const TotalEarlySettlementPage: React.FC = () => {
    const { t } = useTranslation('total-early-settlement');
    const { contractId: encryptedContractId } = useParams<RouteParams>();
    if (!encryptedContractId) return <NoConnectionNotification />;
    return (
        <ContentSection pageWrapSize="medium">
            <PageHeader title={t('headline')} />
            <TotalEarlySettlement encryptedContractId={encryptedContractId} />
        </ContentSection>
    );
};
